import { render } from "./KnowledgeTop.vue?vue&type=template&id=32e3aff6"
import script from "./KnowledgeTop.vue?vue&type=script&lang=js"
export * from "./KnowledgeTop.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__